import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  brandStores: { data: [], loading: false },
  storeBrands: { data: [], loading: false },
  brandOrgs: { data: [], loading: false },
  orgBrands: { data: [], loading: false },
  confirm: { name: '', data: '', title: '', content: '', visible: false, loading: false },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
